import { logAmplitudeEvent } from 'amplitude/amplitude'
import { ComponentVersions_3_0, ComponentVersionsInherit, styled } from 'opensolar-ui'
import { useEffect } from 'react'
import ProjectTable from './projectTable/ProjectTable'

const PageWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  minWidth: 0,
})

const OrderByProjectPage = () => {
  useEffect(() => {
    logAmplitudeEvent('page_viewed', {
      page: 'order_by_project',
    })
  }, [])

  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <PageWrapper>
        <ProjectTable />
      </PageWrapper>
    </ComponentVersionsInherit>
  )
}

export default OrderByProjectPage
